import { render, staticRenderFns } from "./RoomScheduleTable.vue?vue&type=template&id=80ed0132&lang=pug"
import script from "./RoomScheduleTable.vue?vue&type=script&lang=ts"
export * from "./RoomScheduleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports